module.exports = __webpack_public_path__ + "static/media/social-life.46ae79d4.svg";